// extracted by mini-css-extract-plugin
export default {"root":"y9M23","transform":"_3xbWs","swipeable":"_9PUkl","preview":"_2OiDP","next":"_17I2t","prev":"nz2il"};